// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-CX4v","otpInputWrapper":"styles_otpInputWrapper__XjuVR","otpInput":"styles_otpInput__dgOSM","requestOtpButton":"styles_requestOtpButton__fXEPj"};